module.exports = __webpack_public_path__ + "static/media/crown.684c54f4.svg";